import {get, difference, keys, has, keyBy, omit, flatten, map, createReducer} from 'helpers';
import {perDay} from 'store/activities/selectors';

export const progress = createReducer({}, {

  ACTIVITIES_RESCHEDULE: (state, action) => {
    const { id, select, date, time, contextDate, generateId, duration, occurance } = action;
    const activity = select('activities.activity', { id });
    const currentRecord = select('calendar.record', { date, id });

    if (!activity.repeatType) {
      return state;
    }

    if (currentRecord && currentRecord.id != occurance.id) {
      state = omit(state, currentRecord.id);
    }

    const record = {
      originalTimestamp: contextDate.unix(),
      ...createDefault(action),
      ...occurance,
      timestamp: date.unix(),
    }

    if (time !== undefined) {
      record.priority = time;
    }

    if (duration !== undefined) {
      record.duration = duration;
    }

    if (!date.isSame(contextDate)) {
      record.status = 'Not Started';
    }

    if (!date.isSame(contextDate) && select('calendar.matchesRepetition', { date: contextDate })(activity) ) {
      state = {
        ...state,
        [generateId('progress-rescheduled')]: {
          id: generateId('progress-rescheduled'),
          activity_id: id,
          timestamp: contextDate.unix(),
          status: 'Rescheduled',
        }
      }
    }

    return {
      ...state,
      [record.id]: record,
    }
  },

  ACTIVITIES_STATUS_UPDATE: (state, action) => {
    const { activity, subroutines } = action.select('activities.details', { id: action.id });
    if (activity.repeatType) {

      let activities = activity.dailyRoutineType == 'daily_routine' ? subroutines : [ activity ];

      let records = activities.map(activity => ({
        ...createDefault({ ...action, id: activity.id }),
        ...action.select('calendar.record', { date: action.contextDate, id: activity.id }),
        activity,
        action,
      }));

      if (activity.dailyRoutineType == 'daily_routine') {
        const getOccurance = action.select('calendar.occurance', { date: action.contextDate });
        const override = get(getOccurance(activity), 'status') != 'Not Started';
        records = override ? records : records.filter(activity => activity.status == 'Not Started')
      }

      records = records.map(activity => ({ ...activity, ...action.data }))
                       .map(sanitize);

      //@todo fix?
      // if (action.uncomplete) {
      //   return
      // }

      return {
        ...state,
        ...keyBy(records, 'id'),
      }
    }
    return state;
  },

  ACTIVITIES_SUBTASK_STATUS_UPDATE: (state, action) => {
    const { subtask, contextDate, select } = action;
    const record = select('calendar.record', { date: contextDate, id: subtask.parentId });
    if (!record) {
      const newRecord = createDefault({ ...action, id: subtask.parentId });
      return {
        ...state,
        [newRecord.id]: newRecord,
      }
    }
    return state;
  },

  ACTIVITIES_DELETE: (state, { id, select }) => {
    const { subroutines = [] } = select('activities.details', { id });
    let connected = [{ id }, ...subroutines].map(props => select('calendar.activityRecords', props));
    connected = flatten(connected);
    if (connected.length) {
      return omit(state, map(connected, 'id'));
    }
    return state;
  },

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.statuses);
    if (action.statuses.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.statuses, 'id'),
      }, removed);
    }
    return state;
  },

  ACTIVITIES_STORE_GOOGLE_EVENT: (state, { id, googleEventId, generateId, select }) => {
    const records = select('calendar.activityRecords', { id: googleEventId }).map(record => ({
      ...record,
      activity_id: id,
      id: generateId(record.id),
    }));
    if (records.length) {
      return {
        ...state,
        ...keyBy(records, 'id'),
      }
    }
    return state;
  },

  TESTING_DELETE_ALL: () => ({}),
  TESTING_DELETE_PROGRESS: () => ({}),

});

function createDefault({ id, generateId, contextDate }) {
  return {
    activity_id: id,
    count: 0,
    id: generateId('progress-record-for-' + id),
    status: 'Not Started',
    timestamp: contextDate ? contextDate.unix() : null,
  }
}

function sanitize({ action, activity, ...record }) {
  if (has(action, 'data.status')) {
    if (perDay(activity) > 1) {
      if (record.status == 'Completed') {
        if (action.retroperspective) {
          record.count = perDay(activity);
        } else if (++record.count < perDay(activity)) {
          record.status = 'Not Started';
        }
      } else {
        record.count = 0;
      }
    } else {
      record.count = record.status == 'Completed' ? 1 : 0;
    }
  }
  return record;
}
